<template>
  <div>
    <Index></Index>
  </div>
</template>

<script>
import Index from './components/Index.vue'

export default {
  name: 'App',
  components: {
    Index
  },
  setup(){
    var _czc = _czc || [];
(function () {
	var um = document.createElement("script");
	um.src = "https://s4.cnzz.com/z.js?id=1281343408&async=1";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(um, s);
})();
  }
  
}
</script>

<style>


</style>
